/* eslint-disable no-unused-vars -- some imports belong to entries that are commented out below */
import { FaPaintBrush, FaCode, FaMobile, FaBook, FaRobot } from "react-icons/fa"; // Import other icons as needed
import MedApp from "./assets/medapp.png";
import quiz from "./assets/quiz.png";
import elec from "./assets/election.PNG";
import cow from "./assets/coworking.png";
import innovup from "./assets/innovup.png";
import news1 from "./assets/news1.png";
import goldmine from "./assets/goldmine.png";
import marketing from "./assets/marketing.png";
import portfolio from "./assets/portfolio.png";
import BPMFlowApp from "./assets/bpmflow.png";
import ImmoFlowApp from "./assets/immoflow.png";
import CRMBuzzApp from "./assets/crmbuzz2.png";
import ApliviaApp from "./assets/aplivia.png";
import CodeQueryApp from "./assets/codequery-ask.png";
import LitKidsApp from "./assets/litkids.png";

const services = [
 /* {
    id: 1,
    icon: <FaPaintBrush className="service__icon" />,
    title: "UI/UX Design",
    description:
      "Clean, intuitive interfaces built around how people actually use your product — not just how it looks in a mockup.",
  }, {
    id: 3,
    icon: <FaMobile className="service__icon" />,
    title: "Mobile Development",
    description:
      "Custom cross-platform apps with Flutter, built for a smooth experience on both iOS and Android from a single codebase.",
  },
  {
    id: 4,
    icon: <FaBook className="service__icon" />,
    title: "E-books",
    description:
      "End-to-end eBook creation — writing, design, formatting, and publishing — turning your idea into a polished digital product.",
  },*/
  {
    id: 2,
    icon: <FaCode className="service__icon" />,
    title: "Full Stack Development",
    description:
      "Full-stack, API-driven web platforms — from landing pages to complex admin-managed systems — built to be fast, secure, and easy to extend.",
  },
 
  {
    id: 5,
    icon: <FaRobot className="service__icon" />,
    title: "AI Integration",
    description:
      "Adding AI features to real products the right way — structured, validated outputs behind a Generate → Preview → Accept flow, never a black box writing straight to your data.",
  },
];
const projects = [
  {
    id: 1,
    image: ApliviaApp,
    title: "Aplivia — AI Job Application Assistant",
    description:
      "A full-stack assistant that tailors a CV to a specific job offer: match analysis, an ATS readiness check, PDF/Word upload, improvement suggestions and an editable cover letter — with AI output that is schema-validated and grounded against the real CV, so it never invents experience.",
    demo: "",
    caseStudy: "/projects/aplivia",
    keywords: ["Java","Spring Boot",  "Groq LLM API","React", "TypeScript"],
    category: "Websites",
  }, {
    id: 2,
    image: BPMFlowApp,
    title: "BPMFlow – Automated Business Process Management System",
    description:
      "BPMFlow is a business process management platform that enables organizations to model, deploy, and supervise BPMN workflows with integrated DMN decision tables, dynamic forms, and real-time monitoring.",
    demo: "https://app.arcade.software/share/yVEkDM2U2Wsi2WZ5wikP",
    caseStudy: "/projects/bpmflow",
    keywords: ["Java","Spring Boot", "Camunda", "Kafka","React", "TypeScript", "PostgreSQL", "Docker"],
    category: "Websites",
  }, {
    id: 3,
    image: CodeQueryApp,
    title: "CodeQuery – AI-Powered Q&A Platform",
    description:
      "CodeQuery is a Stack Overflow-style community platform with semantic search and RAG: questions are found by meaning, and a local language model writes answers grounded in — and cited from — the community's own discussions.",
    demo: "https://app.arcade.software/share/aMCghWN3Sb7fysoexdXA",
    caseStudy: "/projects/codequery",
    keywords: ["Python", "HuggingFace", "RAG","React","TypeScript", "Node.js", "PostgreSQL" ],
    category: "Websites",
  },
 
  {
    id: 4,
    image: CRMBuzzApp,
    title: "CRMBuzz — White-Label CRM & Dynamic Website Builder",
    description:
      "A full-stack, API-driven CRM/CMS platform: administrators manage pages, navigation, sections, theme and media entirely through the admin dashboard — now with an AI copilot that rewrites, translates and audits content through a Generate → Preview → Accept flow, without ever bypassing the CRUD architecture underneath it.",
    demo: "",
    caseStudy: "/projects/crmbuzz",
    keywords: ["React", "Node.js", "Express", "PostgreSQL", "Google Gemini AI"],
    category: "Websites",
  },

  {
    id: 5,
    image: ImmoFlowApp,
    title: "ImmoFlow – Real Estate Workflow & Data Platform",
    description:
      "ImmoFlow is a real estate agency management platform that streamlines property listings, client appointments, prospect tracking, and team messaging in a single collaborative dashboard.",
    demo: "https://app.arcade.software/share/W8j7S9GsjVRuPtXDJ19K",
    caseStudy: "/projects/immoflow",
    keywords: ["React", "Node JS", "MongoDB"],
    category: "Websites",
  },
 {
    id: 6,
    image: LitKidsApp,
    title: "LitKids — Learn to Read with Joy",
    description:
      "LitKids is an early-literacy web app for children aged 3 to 6: interactive alphabet, phonics, tracing, early-reading and vocabulary activities that feel like play, with stars and badges to keep each session rewarding.",
    demo: "https://lit-kids.vercel.app",
    keywords: ["React", "React Router", "Framer Motion", "Vite"],
    category: "Websites",
  },


  {
    id: 7,
    image: quiz,
    title: "Cosmic Quiz — Personality Quiz Platform",
    description:
      "Nine personality quizzes on one engine — zodiac, 16 personality types, Big Five, Enneagram, love language, spirit animal and more. Each result comes with a blend chart, a “gets along with” match, a shareable result card and a friend-compatibility link, plus live stats and an AI-written reading.",
    demo: "https://quiz-p1jp.vercel.app",
    keywords: ["React", "Redux Toolkit", "Node.js", "Express", "MongoDB", "Claude API"],
    category: "Websites",
  },
  {
    id: 8,
    image: goldmine,
    title: "Digital Goldmine — Your First Digital Product, Step by Step",
    description: "Create, Launch, and Unlock $100/Day with Your First Digital Product",
    code: "",
    demo: "https://wafabenmiloud.gumroad.com/l/goldmine",
    keywords: ["#money", "#buisiness", "#digital products"],
    category: "E-books",

  },
  {
    id: 9,
    image: marketing,
    title: "Email Marketing Cheatsheet",
    description: "Want to turn your email subscribers into loyal customers? This ebook will walk you through creating high-converting email campaigns, step-by-step.",
    code: "",
    demo: "https://wafabenmiloud.gumroad.com/l/goldmine",
    keywords: ["#digital products", "#email", "#marketing"],
    category: "E-books",

  },
  /* {
     id: 5,
     image: COT,
     title: "IoT Innovate",
     description:
       "Welcome to IoT Innovate, the collaborative hub for IoT developers around the world. Join our community today and be a part of the IoT revolution!",
     demo: "https://cot.vercel.app/",
     keywords: ["HTML", "CSS", "JavaScript", "Bootstrap"],
     category: "Websites",
   },
   {
     id: 6,
     image: todo,
     title: "ToDo",
     description: "",
     demo: "https://tasks-manager-iota.vercel.app",
     keywords: ["Next JS", "Nest JS", "PostgreSQL"],
     category: "Websites",
   },
   {
     id: 7,
     image: innovup,
     title: "Smart Tracking Vehicle System",
     description:
       "Intelligent vehicle tracking system utilizing GPS technology, real-time vehicle data monitoring stored in the cloud.",
     code: "",
     demo: "",
     keywords: [
       "Flutter",
       "NodeJS",
       "ExpressJS",
       "MongoDB",
       "IOT",
       "C++",
       "GPS",
     ],
     category: "Mobile Applications",
   },
   {
     id: 8,
     image: MedApp,
     title: "HealthBook",
     description:
       "HealthBook is a comprehensive appointment booking platform that connects patients with their preferred doctors.",
     demo: "",
     keywords: ["Flutter", "Node JS", "MongoDB"],
     category: "Mobile Applications",
   },
 
   {
     id: 9,
     image: cow,
     title: "Coworking Space",
     description:
       "Creation of a mobile application for the management of coworking spaces, including booking and user management features.",
     demo: "",
     keywords: ["Flutter", "MySQL"],
     category: "Mobile Applications",
   },
   {
     id: 10,
     image: elec,
     title: "Elections Game",
     description:
       "This Flutter game allows you to step into the shoes of a president, where you create an avatar and lead your country through various challenges and decisions. As the leader, you'll navigate the complexities of governance, aiming to build a prosperous and stable nation.",
     code: "https://github.com/wafabenmiloud/ElectionGame",
     demo: "",
     keywords: ["Flutter", "Sqlite"],
     category: "Mobile Applications",
   }, {
     id: 11,
     image: bookLover,
     title: "BookLover - Digital library",
     description:
       "Online Library offering standard library functions such as searching for a book, borrowing a book, and returning a book...",
     demo: "https://digital-library-tawny.vercel.app",
     keywords: ["React JS", "PHP", "MySql"],
     category: "Websites",
   },
   {
     id: 12,
     image: Go,
     title: "Govact",
     description:
       "Hammam Lif Connect is a community-driven platform that aims to connect the residents of Hammam Lif with their local municipality. ",
     demo: "https://govact.onrender.com/",
     keywords: ["React JS", "Node JS", "MongoDB"],
     category: "Websites",
   },{
     id: 11,
     image: bank,
     title: "Bank Management System",
     description:
       "A comprehensive app for managing bank accounts, enabling customers to create and manage accounts, perform transactions, and communicate with customer service. Administrators can oversee and manage customer accounts efficiently.",
     code: "https://github.com/wafabenmiloud/BankManagement",
     demo: "",
     keywords: ["Java", "MongoDB"],
     category: "Websites",
   },
   {
     id: 12,
     image: movies,
     title: "Redux",
     description: "",
     code: "https://github.com/wafabenmiloud/Redux",
     demo: "https://movies-kappa-three.vercel.app",
     keywords: ["React JS"],
     category: "Websites",
 
   },*/

];
const testimonials = [
  /*{
    id: 1,
    quote:
      "Une développeuse à l’écoute et vraiment très rapide. Merci Wafa",
    name: "Mohamed Bouhlel",
    position: "UPWORK",
  },
  {
    id: 2,
    quote:
      "This book is an absolute masterpiece. the sheer beauty of the writing drew me in from the first page. Every chapter feels like a work of art, full of insight and knowledge. It's the kind of book that stays with you long after you've finished reading.",
    name: "Achref Rihani",
    position: "GUMROAD",
  },*/
  {
    id: 3,
    quote:
      "well-written Book. Highly recommended!",
    name: "Oussema Bersellou",
    position: "GUMROAD",
  },
 /* {
    id: 4,
    quote:
      "Une développeuse qui connaît bien son travail. Merci",
    name: "Mohamed Bouhlel",
    position: "UPWORK",
  },*/
  {
    id: 5,
    quote:
      "A very serious and competent person. I recommend her for your projects",
    name: "Mohamed Bouhlel",
    position: "UPWORK",
  },
  {
    id: 6,
    quote:
      "Une personne professionnelle et sérieuse. Je la recommande.",
    name: "Mohamed Bouhlel",
    position: "UPWORK",
  },
];
const news = [ {
    id: 1,
    title: "Modern & Responsive React.js Portfolio Template",
    cover: portfolio,
    keywords: ["ReactJs", "Template", "Portfolio", "Gumroad"],
    link: "https://wafabenmiloud.gumroad.com/l/portfolio",
  },
  {
    id: 2,
    title: "You will get Fully Functional Flutter App with Seamless Figma to Flutter Conversion.",
    cover: news1,
    keywords: ["Flutter", "Android", "Cross Browser", "Frontend", "Backend", "Service", "Upwork"],
    link: "https://www.upwork.com/services/product/development-it-fully-functional-flutter-app-with-seamless-figma-to-flutter-conversion-1829298719988717417",
  },
  {
    id: 3,
    title: "Digital Goldmine: Create, Launch, and Unlock $100/Day with Your First Digital Product (+ Email Marketing Strategies)",
    cover: goldmine,
    keywords: ["digital products", "email", "marketing", "money", "buisiness", "Gumroad"],
    link: "https://wafabenmiloud.gumroad.com/l/goldmine",
  }

];

export { projects, services, testimonials, news };
